import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Question } from 'src/app/models/question.model';
import { throwIfEmpty } from 'rxjs/operators';
import { CourseService } from 'src/app/services/course.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-quiz-dialog',
  templateUrl: './quiz-dialog.component.html',
  styleUrls: ['./quiz-dialog.component.css']
})
export class QuizDialogComponent implements OnInit {

  @Input() lessonId:string = ''
  @Input() show: boolean = false;
  @Input() showHistoryButton: boolean = true
  @Input() questions: Question[] = []
  @Input() instruction:string = ''
  @Input() audioUrl:string = ''
  @Input() audio:any = null
  @Input() resultScore:number = 0
  @Output() onDismissCallback: EventEmitter<boolean> = new EventEmitter()
  @Output() onSubmitCallBack: EventEmitter<string> = new EventEmitter()

  @Output() onRetryQuizCallback: EventEmitter<string> = new EventEmitter()
  @Output() onShuffleQuizCallback: EventEmitter<string> = new EventEmitter()
  @ViewChild('quizAudio') quizAudio!: ElementRef<HTMLAudioElement>;
  display = 'none';

  currentQuestion: Question = new Question()
  currentIndex:number = 1

  @Input() isLeftVisible:boolean = true

  isShowHistory:boolean = false

  isShowResult:boolean = false

  dialogTitle:string = "Quiz"

  

  constructor(  
    private sanizer: DomSanitizer,
   ) { }

  ngOnInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.questions) {
      this.currentQuestion = this.questions[0]
      this.currentIndex = 1
      console.log(this.currentQuestion)
    }
    if (this.show) {
      this.display = "block";
    } else {
      this.display = "none";
    }
  }

  get audioSource(): string {
    if (this.audioUrl) {
      return this.audioUrl
    }

    if (typeof this.audio === 'string' && this.audio) {
      return this.audio
    }

    if (this.audio && typeof this.audio === 'object') {
      if (this.audio.fileUrl) {
        return this.audio.fileUrl
      }

      if (this.audio.url) {
        return this.audio.url
      }
    }

    return ''
  }

  onClose() {
    if (this.quizAudio) {
      this.quizAudio.nativeElement.pause();
      this.quizAudio.nativeElement.currentTime = 0;
    }
    this.onDismissCallback.emit()
  }

  moveNext(){
    const index:number = this.currentIndex < this.questions.length  ? this.currentIndex + 1  : this.currentIndex
    if(index <= this.questions.length){
      this.currentIndex = index
      this.currentQuestion = this.questions[index-1]
    }
    
  }
  movePrevious(){
    const index:number = this.currentIndex - 1 > 1 ? this.currentIndex - 1 : 1
    this.currentIndex = index
    this.currentQuestion = this.questions[index-1]
  }

  onSubmit() {
    this.onSubmitCallBack.emit()
  }

  onShowHistory(){
    this.isShowHistory = true
    this.dialogTitle = "Quiz History"
  }

  onHideHistory(){
    this.isShowHistory = false
  }

  onRetryQuiz(){
    this.onRetryQuizCallback.emit();
  }

  onShuffleQuiz(){
    this.onShuffleQuizCallback.emit();
  }


  senitizeHtmlContent(value: string) {

    const html = this.sanizer.bypassSecurityTrustHtml(value);

    return html;

  }


}
